module.exports = __webpack_public_path__ + "img/visa.07c62f06.jpg";